import { computed } from '@ember/object';
import { alias, equal, gt } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import ItemDetail from '@square/dashboard-data/models/squareup/beemo/api/v2/models/item-detail';
import Enum from '@square/dashboard-utilities/utils/enum';
import Adjustment from '@square/dashboard-data/models/squareup/beemo/api/v2/models/adjustment';
import NameOrTranslationType, { TranslationType } from '@square/dashboard-data/models/squareup/beemo/translation-types/name-or-translation-type';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
// eslint-disable-next-line ember/no-mixins
import DisplayNameMixin from '@square/dashboard-data/mixins/display-name-mixin';
import GiftCardDetails from '@square/dashboard-data/models/squareup/beemo/api/v2/models/gift-card-details';
import QuantityUnit from '@square/dashboard-data/models/orders/quantity-unit';
import { Event } from '@square/dashboard-data/models/squareup/bills/itemization';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Employee from '@square/dashboard-data/models/squareup/beemo/api/v2/models/employee';
import ItemizationFeatureDetails from '@square/dashboard-data/models/squareup/beemo/api/v2/models/itemization-feature-details';
const DiningOptionType = new Enum('DEFAULT', 'SELECTED');
const DiningOption = ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  type: attr(DiningOptionType),
  ordinal: attr(Number)
});
const EmployeeAttribution = ProtoBaseModel.extend({
  employee: attr(Employee)
});
export default ProtoBaseModel.extend(DisplayNameMixin, {
  quantity: attr(Number),
  nameOrTranslationType: attr(NameOrTranslationType),
  totalMoney: attr(MoneyProto),
  singleQuantityMoney: attr(MoneyProto),
  multipleQuantityMoney: attr(MoneyProto),
  grossSalesMoney: attr(MoneyProto),
  discountMoney: attr(MoneyProto),
  refundedMoney: attr(MoneyProto),
  netSalesMoney: attr(MoneyProto),
  itemVariationName: attr(String),
  itemDetail: attr(ItemDetail),
  itemizationNotes: attr(String),
  description: attr(String),
  giftCardDetails: attr(GiftCardDetails),
  quantityUnit: attr(QuantityUnit),
  displayQuantity: attr(String),
  employeeAttributions: repeated(EmployeeAttribution),
  commissionBasisPoints: attr(Number),
  commissionMoney: attr(MoneyProto),
  itemCommissionMoney: attr(MoneyProto),
  tierMin: attr(Number),
  tierMax: attr(Number),
  tierUnit: attr(String),
  featureDetails: attr(ItemizationFeatureDetails),
  discounts: alias('discount'),
  discount: repeated(Adjustment),
  diningOption: attr(DiningOption),
  taxes: alias('tax'),
  tax: repeated(Adjustment),
  itemModifiers: alias('itemModifier'),
  itemModifier: repeated(Adjustment),
  isCustomAmount: equal('nameOrTranslationType.translationType', TranslationType.CUSTOM_AMOUNT_ITEM),
  quantityIsMultiple: gt('quantity', 1),
  event: repeated(Event),
  events: alias('event'),
  // Used for linking to a specific itemization group (see ./transaction.js)
  appliedItemizationGroups: repeated(String),
  // dz: This was a server-side hack that is going away in the near future.
  // In the mean time in the name of backward-compatibility we are going to do this on client side
  // until the server-data is fixed.
  effectiveItemizationNotes: computed('itemizationNotes', 'description', function () {
    const itemizationNotes = this.itemizationNotes;
    if (!isEmpty(itemizationNotes)) {
      return itemizationNotes;
    }
    return this.description;
  }),
  isVoid: false,
  // set on models/transaction.js

  voidEvent: computed('events.[]', function () {
    return (this.events === undefined ? [] : this.events).findBy('isVoid');
  })
});